import { render, staticRenderFns } from "./AdminEventhub.vue?vue&type=template&id=1e9bf77c"
import script from "./AdminEventhub.vue?vue&type=script&lang=js"
export * from "./AdminEventhub.vue?vue&type=script&lang=js"
import style0 from "./AdminEventhub.vue?vue&type=style&index=0&id=1e9bf77c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports